module.exports = __webpack_public_path__ + "img/rightthigh-ectomorph-male.24a52906.svg";